// File: custom-transition.js
// Import Highway
import Highway from './highway';
import gsap from 'gsap'
import stage from '../components/stage'

class CustomTransition extends Highway.Transition {
  // Built-in methods

  in({ from, to, trigger, done }) {

         gsap.fromTo(to,
           {opacity: 1},
           {
            opacity: 1, delay: .5, duration: .5, ease: "power4.inOut",
            onComplete: ()=>{
              done()
            }
           }
         );

         from.remove();


  }

  out({ from, trigger, done }) {

    gsap.to(from,.5,
      {
       opacity: 1,
       ease: "power4.inOut",
       onComplete: done
      }
    );

  }
}

// Don`t forget to export your transition
export default CustomTransition;
